/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["table[_ngcontent-%COMP%]{width:100%}.Active[_ngcontent-%COMP%]{background:#99d896!important;color:#000;text-align:center!important}.Inactive[_ngcontent-%COMP%]{background:#e06363;color:#000;text-align:center!important}\n/*# sourceMappingURL=table.component.css.map*/"];
export { styles as styles };
